import { gql } from '@apollo/client';
import { AccountCreditCardInfoShared } from '../fragments';

export default gql`
  mutation destroyAccountCreditCard($input: AccountCreditCardDestroyInput!) {
    destroyAccountCreditCard(input: $input) {
      clientMutationId
      accountCreditCard {
        ...AccountCreditCardInfoShared
      }
    }
  }
  ${AccountCreditCardInfoShared}
`;
